import { AuthContext } from 'contexts';
import { useContext } from 'react';

/**
 * Shared hook to determine the overdue payment stage of a user or an org/brokerage.
 * */
const useOverduePaymentStage = () => {
  const { auth } = useContext(AuthContext);

  // Check if isInBillingCollection and supraPaid are exactly true/false in the case where these fields aren't set, which
  // happens when the user or org/brokerage does not have a billing profile set up for them yet.
  const isUserSuspended =
    auth.isInBillingCollection === false && auth.supraPaid === false;
  const isOrgSuspended =
    auth.org?.isInBillingCollection === false && auth.org?.supraPaid === false;
  const isUserDeactivated =
    auth.isInBillingCollection === true && auth.supraPaid === false;
  const isOrgDeactivated =
    auth.org?.isInBillingCollection === true && auth.org?.supraPaid === false;

  return {
    isUserSuspended,
    isOrgSuspended,
    isUserDeactivated,
    isOrgDeactivated,
  };
};

export default useOverduePaymentStage;
